import { FC } from "react";
import { TSupplierDTO } from "Types";
import TextareaAutosize from "react-textarea-autosize";

import styles from "./supplier.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

type TSupplierProps = {
    isEditMode: boolean,
    supplier: TSupplierDTO,
    updateSupplier?: (supplier: TSupplierDTO) => void
}

export const Supplier: FC<TSupplierProps> = ({ isEditMode, supplier, updateSupplier }: TSupplierProps) => {

    const onChangeCompanyName = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!updateSupplier) return;
        updateSupplier({ ...supplier, companyName: event.target.value });
    };

    const onChangePageTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!updateSupplier) return;
        updateSupplier({ ...supplier, pageTitle: event.target.value });
    };

    const onChangeDescription = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (!updateSupplier) return;
        updateSupplier({ ...supplier, pageDescription: event.target.value });
    };

    const onRemoveImageUrl = () => {
        if (!updateSupplier) return;
        updateSupplier({ ...supplier, pageImageUrl: undefined });
    };

    // Determine if the supplier contains any meaningfull information, if so show the complete preview
    // otherwise only show the link and maybe the favicon
    const hasMeaningfullInformation = supplier.pageTitle && supplier.pageDescription;

    return (
        <div className={styles.supplierContainer}>
            {!isEditMode && supplier.url && !hasMeaningfullInformation ?
                <div className={styles.supplierUrlContainer}>
                    {supplier.faviconUrl ?
                        <img className={styles.favicon} src={supplier.faviconUrl} alt={"Icon of supplier"} />
                        : <FontAwesomeIcon icon={faExternalLinkAlt} /> }
                    <a href={supplier.url} target="_blank" rel="noopener noreferrer">
                        <span>{supplier.url}</span>
                    </a>
                </div>
                : null}

            {isEditMode || hasMeaningfullInformation ?
                <div className={styles.pageContentContaier}>
                    {supplier.pageImageUrl ?
                        <div className={styles.imageContainer}>
                            <div className={styles.aspectRatioBox}>
                                <div className={styles.aspectRatioBoxContent}>
                                    <img className={styles.image} src={supplier.pageImageUrl} alt={supplier.pageTitle ?? "Image describing the url"} />
                                </div>
                            </div>
                            {isEditMode ?
                                <div onClick={onRemoveImageUrl} className={styles.removeImage} title="Delete image">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </div>
                                : null }
                        </div>
                        : null
                        // <>
                        //     {isEditMode ?
                        //         <div className={styles.pageImageFloater}>
                        //             <div className={styles.emptyImageBorder}>
                        //                 <FontAwesomeIcon icon={faImage} />
                        //             </div>
                        //         </div>
                        //         : null}
                        // </>
                    }
                    <div className={styles.companyHeader}>
                        {supplier.faviconUrl && supplier.companyName ?
                            <img className={styles.favicon} src={supplier.faviconUrl} alt={supplier.companyName ?? "Icon of supplier"} />
                            : 
                            <>
                                {supplier.faviconUrl && isEditMode ?
                                    <img className={styles.favicon} src={supplier.faviconUrl} alt={supplier.companyName ?? "Icon of supplier"} />
                                    : null}
                            </>
                            }
                        
                            {!isEditMode && supplier.companyName ?
                                <div className={styles.companyName}>
                                    <h5>{supplier.companyName}</h5>
                                </div>
                                :
                                <>
                                    {isEditMode ?
                                        <div className={styles.companyName} >
                                            <input onChange={onChangeCompanyName} defaultValue={supplier.companyName ? supplier.companyName : ""} type="text" placeholder="Company name" autoComplete="off" />
                                        </div>
                                        : null}
                                </>
                            }
                        
                    </div>
                    <div className={styles.pageTitle}>
                        {supplier.faviconUrl && !supplier.companyName && !isEditMode ?
                            <img className={styles.favicon} src={supplier.faviconUrl} alt={supplier.companyName ?? "Icon of supplier"} />
                            : null}
                        {!isEditMode && supplier.pageTitle ?
                            <a href={supplier.url ?? undefined} target={"_blank"} rel={"noopener noreferrer"}>
                                <h5>{supplier.pageTitle}</h5>
                            </a>
                            :
                            <>
                                {isEditMode ?
                                    <input onChange={onChangePageTitle} defaultValue={supplier.pageTitle ? supplier.pageTitle : ""} type="text" placeholder="Page title" autoComplete="off" />
                                    : null
                                }
                            </>
                        }
                    </div>
                    <div className={styles.pageDescription}>
                        {!isEditMode && supplier.pageDescription ?
                            <p>{supplier.pageDescription}</p>
                            :
                            <>
                                {isEditMode ?
                                    <TextareaAutosize onChange={onChangeDescription} defaultValue={supplier.pageDescription ? supplier.pageDescription : ""} placeholder="Page description" autoComplete="off" />
                                    // <div contentEditable="true">{supplier.pageDescription ? supplier.pageDescription : ""}</div>
                                    : null}
                            </>
                        }
                    </div>
                </div>
                : null}
        </div>
    );
};